<template>
  <v-card-text >
        <div class="row login">
          <template>
            <div class="login-card">
              <v-row class="relative">
                <!--            *****************************-->
                <v-col cols="12" class="pa-1">

            <span>
                {{request_info.RequestName}}
              </span>
                </v-col>
                <v-col cols="12" class="pa-1">

            <span>
                {{request_info.LastStatus}}
              </span>
                </v-col>
                <!--            *****************************-->
                <v-col cols="12" class="pa-1">

                  <v-btn
                    label=""
                    color="primary"
                    style="padding: 2px"

                    width="100%"

                  >{{ $t('technician') }}</v-btn>
                </v-col>
                <v-col cols="12" class="pa-1">

            <span>
                {{request_info.ExpertName}}
              </span>
                </v-col>


              </v-row>
              <!--            *****************************-->

              <v-row class="relative">
                <v-col cols="12" class="pa-1">
                  <v-btn
                    label=""
                    width="100%"
                    style="padding: 2px"

                    color="primary"
                  >{{ $t('devicePassword') }}</v-btn>
                </v-col>
                <v-col cols="12" class="pa-1" >

            <span>
                {{request_info.DevicePass}}
              </span>
                </v-col>

              </v-row>
              <!--            *****************************-->
              <v-row class="relative">
                <v-col cols="12" class="pa-1">
                  <v-btn
                    label=""
                    width="100%"
                    style="padding: 2px"

                    color="primary"
                  >{{ $t('apparenceProblem') }}</v-btn>
                </v-col>
                <v-col cols="12" class="pa-1">

            <span>
                {{request_info.AppearanceProblem}}
              </span>
                </v-col>

              </v-row>
              <!--            *****************************-->
              <v-row class="relative">
                <v-col cols="12" class="pa-1">
                  <v-btn
                    label=""
                    width="100%"
                    style="padding: 2px"

                    color="primary"
                  >{{ $t('phoneNo') }}</v-btn>
                </v-col>
                <v-col cols="12" class="pa-1">

            <span>
                {{request_info.CustomerMobile}}
              </span>
                </v-col>

              </v-row>
              <!--            *****************************-->
              <v-row class="relative">
                <v-col cols="12" class="pa-1">
                  <v-btn
                    label=""
                    width="100%"
                    style="padding: 2px"
                    color="primary"
                  >{{ $t('expertOpenion') }}</v-btn>
                </v-col>
                <v-col cols="12" class="pa-1">

            <span>
                {{request_info.ExpertOpinion}}
              </span>
                </v-col>

              </v-row>
              <!--            *****************************-->
              <v-row class="relative">
                <v-col cols="12" class="pa-1">
                  <v-btn
                    label=""
                    width="100%"
                    style="padding: 2px"
                    color="primary"
                  >{{ $t('predefined') }}</v-btn>
                </v-col>
                <v-col cols="12" class="pa-1">
                  <div class="text-center">
                    <v-chip v-for="item in request_info.PredefinedGlobal"
                            class="ma-1"
                            color="primary"
                    >
                      {{item.Text}}:{{item.Value}}
                    </v-chip>

                    <v-chip
                      v-for="item in request_info.PredefinedChecked"
                      class="ma-1"
                      color="primary"
                    >
                      {{item.Text}}:{{item.Value}}

                    </v-chip>
                  </div>

                </v-col>

              </v-row>

              <!--            *****************************-->
              <v-row class="relative">
                <v-col cols="12" class="pa-1">
                  <v-btn
                    label=""
                    width="100%"
                    style="padding: 2px"
                    color="primary"
                  >{{ $t('priceRange') }}</v-btn>
                </v-col>
                <v-col cols="12" class="pa-1">

            <span>
                {{request_info.TechPriceRange}}
              </span>
                </v-col>

              </v-row>
              <!--            *****************************-->

              <!--            *****************************-->


            </div>

            <div id="app" style="background-color: white">
              <VueSignaturePad width="90%" height="500px" ref="signaturePad" :options="signature_options" />

            </div>
            <v-row>

              <v-col>
                <v-btn color="primary" v-on:click="save()">
                  {{ $t('save') }}
                </v-btn>
              </v-col>
              <v-col>
                <v-btn color="primary" v-on:click="undo()">{{ $t('delete') }}</v-btn>
              </v-col>

            </v-row>
          </template>
        </div>


  </v-card-text>

</template>
<script>
  import Vue from 'vue';

  import VueSignaturePad from 'vue-signature-pad';
  import {bus} from "../../main";

  Vue.use(VueSignaturePad);
  export default {
    name: 'MySignaturePad',
    data(){
      return {
        signature_options: {
          dotSize: (0.5 + 2.5) / 2,
          minWidth: 0.5,
          maxWidth: 2.5,
          throttle: 16,
          minDistance: 5,
          backgroundColor: 'rgb(255,255,255)',
          penColor: 'black',
          velocityFilterWeight: 0.7,
          onBegin: () => {
          },
          onEnd: () => {
          }
        },
        req_type:4,
        request_info: [],

      }
    },mounted() {
      this.req_type = this.$route.params.type_id
      this.get_request_info();
    },
    methods: {
      undo() {
        this.$refs.signaturePad.clearSignature();
      },
      save() {
        const { isEmpty, data } = this.$refs.signaturePad.saveSignature('image/png');
        // var data_image = this.$refs.signaturePad.getPropImagesAndCacheImages()
        // console.log(this.$refs.signaturePad.getPropImagesAndCacheImages());
        // console.log(data);
        //Usage example:
        var file = this.dataURLtoFile(data,'signature.png');
        console.log(file);
        // this.$refs.signaturePad.fromData(data)
        this.upload_image(file);
      },
      upload_image(image_data){
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;
        console.log();
        var form_data = new FormData();
        form_data.append("UserId",user_id);
        form_data.append("ProcessId",this.$route.rec_id);
        form_data.append("Format","png");
        form_data.append("ReqType",this.req_type);
        form_data.append("Picture",image_data);

        //
        // const send_data = {
        //   "UserId": user_id,
        // };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('UploadFile', form_data, {})
          .then(response => {
self.send_signature(response.data.ArchiveId,response.data.ImageName);

          }).catch(e => {
          this.errors.push(e);

        })

      },
      dataURLtoFile(dataurl, filename) {

    var arr = dataurl.split(','),
      mime = arr[0].match(/:(.*?);/)[1],
      bstr = atob(arr[1]),
      n = bstr.length,
      u8arr = new Uint8Array(n);

    while(n--){
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, {type:mime});
  },


      send_signature(archive_id,file_name){
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId;
        console.log();

        var sign_type = 0;

        if (this.req_type == 4) {
          sign_type = 1;
        }
        if (this.req_type == 5) {
          sign_type = 2;
        }


        const send_data = {
          "UserId": user_id,
          "ProcessId": this.$route.params.rec_id,
          "ImageName": file_name,
          "ArchiveId": archive_id,
          "SigType": sign_type,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/SetRequestSignature', send_data, {})
          .then(response => {
           if(response.data.error == 0){
             // self.$router.push({name: 'attachment', params: {'rec_id': self.$route.params.rec_id}})
           if(self.req_type== 4 || self.req_type== 5){
             self.$router.push({name: 'requestAddress', params: {'rec_id': self.$route.params.rec_id}})

           }


           }else{
             bus.$emit('show_toast', [1500, self.$t('errorOnSignature')])

           }


          }).catch(e => {
          this.errors.push(e);

        })

      },
      get_request_info() {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        const send_data = {
          "ExpertId": user_id,
          "RequestId": this.$route.params.rec_id,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetRequestInfoByReqId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              this.request_info = response.data.rec;
            }
            // this.$router.push({ path: "/post-login", params: {} });

          }).catch(e => {
          this.errors.push(e);

        })

      },



    }
  };
</script>
